import React from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { GlobalStates } from "../GlobalStates";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import PrimaryButton from "../Components/Button/PrimaryButton";

import { useSupabaseData } from "../Hooks";
import PrimaryAccordionCreator from "../Components/PrimaryAccordion/PrimaryAccordionCreator";

const CreatorTable = () => {
    const navigate = useNavigate();
    const { token, path } = useContext(GlobalStates)
    const { t } = useTranslation()
    
    const { data: info, getAll, create } = useSupabaseData({ name: 'formos_tipai' }, []);
    useEffect(() => { getAll() }, [getAll])
    
    const edit = async (id) => {
        let ObjectInfo = { token: token, path: path, what: 'formos-tipai' }
        navigate('/Creator/' + id, { state: { id: id, ObjectInfo: ObjectInfo } })
    }
    

    const sorter = (arr => {
        arr.sort((a, b) => {
            return a.id - b.id
        })

        return arr
    })
    return (
        <div className="Creator standartPadding">
            <div className="row name_action">
                <p className="accorcionName">{t('apklausos_label')}</p>
                <PrimaryButton
                    width={150}
                    onClick={async () => { await create(); getAll() }}
                    text='create'
                    variant="text"
                    className='nauja_apklausa'
                    sx={{
                       boxShadow: 0,':hover': {
                          
                        boxShadow:"1px 1px 5px lightgrey",
                            },
                    }}
                />
            </div>
            <PrimaryAccordionCreator
                edit={edit}
                r={() => { getAll() }}
                elements={sorter(info)}
                className='accordionRes'
                getAll={getAll}
            />
        </div>)
}
export default CreatorTable
